import { inject, Injectable } from '@angular/core';
import { GoogleAnalyticsService } from '../../google-analytics.service';

@Injectable({providedIn: 'root'})
export class AnalyticsAuthService {


    gAnalytics = inject(GoogleAnalyticsService);

    trackLogout() {
        this.gAnalytics.trackEvent('logout', {
            page:'/',
            action: 'Usuario ha cerrado sesión'
        });
    }



    trackLogin() {
        this.gAnalytics.trackEvent('login', {
            page:'/iniciar-sesion',
            action: 'Usuario ha iniciado sesión'
        });
    }

    trackRecoverPassword() {
        this.gAnalytics.trackEvent('recover_password', {
            page:'/recuperar-contrasena',
            action: 'Usuario ha solicitado recuperación de contraseña'
        });
    }
    

    trackChangePassword() {
        this.gAnalytics.trackEvent('change_password', {
            page:'/',
            action: 'Usuario ha cambiado su contraseña'
        });
    }

    trackCompleteRegistration() {
        this.gAnalytics.trackEvent('complete_registration', {
            page:'/registrar-usuario',
            action: 'Usuario ha completado el registro'
        });
    }

}